import * as Loadable from 'react-loadable'

import ModalLoading from '../modalLoading'

export default (Loadable as any)({
  loader: () =>
    import(/* webpackChunkName: "getFeedbackModal" */ './getFeedback'),
  loading: ModalLoading,
  webpack: () => [require.resolveWeak('./getFeedback')],
  modules: ['./getFeedback']
})
